export type JsonString = string;

export function safeParse<T = any>(jsonString: JsonString): T | null {
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    return null;
  }
}
